<template>
  <v-card flat>
    <h1>{{ $t('application.profession.title') }}</h1>
    <p v-if="isApprentice && !isCompanyUser(0)">{{ $t('application.profession.info') }}</p>
    <p v-if="isCompanyUser(0)">{{ $t('application.profession.instructor-info') }}</p>

    <!-- Form with profession name input field -->
    <v-form>
      <v-text-field
        v-model="search"
        class="search-field mb-5"
        prepend-icon="$sl-search"
        single-line
        hide-details
        :label="$t('application.search-label')"
      />
    </v-form>

    <!-- Display professions as a list including machine professions if any -->
    <v-card flat>
      <v-list class="height-small">
        <v-list-item-group v-model="model" :multiple="false" :mandatory="true">
          <template v-for="(item, index) in searchedItems">
            <v-list-item :key="item.title" @click="clickProfession(item)">
              <v-list-item-icon>
                <v-icon>$sl-{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content class="ml-4">
                <v-list-item-title class="body-1" v-html="item.shortname"></v-list-item-title>
                <v-list-item-subtitle v-if="item.isMachineProfession">{{ $t('labels.machines') }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <div class="v-list-item__radio">
                  <input type="radio" v-model="model" :value="index" />
                  <div class="check">
                    <div class="inside"></div>
                  </div>
                </div>
              </v-list-item-action>
            </v-list-item>
            <v-divider :key="index"></v-divider>
          </template>
        </v-list-item-group>
      </v-list>
    </v-card>

    <ApplicationTransferDialog
      :is-visible="transferDialogIsVisible"
      :profession="profession"
      @close="closeApplicationTransferDialog()"
    >
      <template #actions>
        <ActionButton
          :block="false"
          class="mt-4 ml-auto"
          smallerText
          actionIcon="$sl-like"
          @click="readInformation()"
        >{{ $t('labels.ok') }}</ActionButton>
      </template>
    </ApplicationTransferDialog>

    <ApplicationTransferDialog
      :is-visible="transferMachineProffesionDialog"
      :profession="profession"
      :width="350"
      is-machine-profession
      @close="closeApplicationTransferDialog()"
      @proceed="readInformation()"
      v-if="hasProfessionOrientations(application.professionId)"
    >
      <template #actions>
        <ActionButton
          :block="false"
          class="flex-grow-1 mt-4 mb-4"
          smallerText
          :depressed="false"
          actionIcon="$sl-company"
          @click="readInformation()"
        >{{ $t('labels.machine-profession.btn-label.change-company') }}</ActionButton>
        
        <ActionButton
          :block="false"
          class="flex-grow-1 mb-4"
          smallerText
          :depressed="false"
          actionIcon="$sl-tractor"
          @click="createNewApplication()"
        >{{ $t('labels.machine-profession.btn-label.new-machine') }}</ActionButton>
      </template>
    </ApplicationTransferDialog>

    <!-- Enable button display button text based on is company or apprentice application-->

    <NextButton      
      v-if="isCompanyUser(0) && selectedApplication && selectedApplication.isCompanyApplication==true"      
      :isEnterSubmit="false"
      @click="nextStep"
    >
      {{        
          (hasProfessionOrientations(application.professionId)==true) ? $t('labels.machineOrientationBtnTxtNextStep') : $t('tour.next')
      }}
    </NextButton>
    <NextButton
      v-else-if="isCompanyUser(0) && !isApprentice && application"
      
      :isEnterSubmit="false"
      @click="nextStep"
    >
      {{
        application && application.professionId && hasProfessionOrientations(application.professionId)
          ? $t('labels.machineOrientationBtnTxtNextStep')
          : $t('tour.next')
      }}
    </NextButton>

    <NextButton v-else @click="nextStep">
      {{
        application && application.professionId && hasProfessionOrientations(application.professionId)
          ? $t('labels.machineOrientationBtnTxtNextStep')
          : $t('tour.next')
      }}
    </NextButton>

    <!-- Go to a previous  step-->
    <BottomNav @clicked="clickBack" />
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapActions, mapGetters} from 'vuex'
import pick from 'lodash/pick'
import get from 'lodash/get'
import BottomNav from '@/components/Application/BottomNav'
import NextButton from '@/components/Common/NextButton'
import ApplicationTransferDialog from '@/components/Application/ApplicationTransferDialog.vue'
import ActionButton from '@/components/Common/ActionButton.vue'
import Sugar from 'sugar'

// @group Applications/Common
// ApplicationCompanies component
export default {
  name: 'ApplicationProfession',

  components: {
    BottomNav,
    NextButton,
    ApplicationTransferDialog,
    ActionButton
  },

  data() {
    return {
      professions: [],
      search1: 'search',
      dissBtn: true,
      activeColor: '#fcf6ac!important',
      search: '',
      application: {},
      model: 0,
      fields: [
        'id',
        'professionId',
        'step',
        'professionOrientations',
        'educationId'
      ],
      transferDialogIsVisible: false,
      transferMachineProffesionDialog: false,
      haveReadInformation: false,
      profession: ''
    }
  },

  created() {
    if (this.currentUser && this.currentUser.personalNumber) {
      this.initApplication()
    }
  },

  watch: {
    /**
     * @vuese
     * Used to watch the selectedApplication and call initApplication and fetch professions
     * @arg called with no argument
     */
    selectedApplication: {
      handler: function () {
        this.initApplication()
        this.fetchProfessions()
      },
      deep: true
    },
    /**
     * @vuese
     * Used to watch the currentStep and call initApplication and fetch professions
     * @arg called with no argument
     */
    currentStep: {
      handler: function (value) {
        this.initApplication()
        this.fetchProfessions()
      },
      deep: true
    },
    /**
     * @vuese
     * Used to dissable button if no profession is selected
     */
    model: {
      handler: function () {
        if (this.model === undefined) {
          this.dissBtn = true
        }

        this.profession = this.basicProfessions?.find((o, idx) => idx === this.model && o) || this.basicProfessions[0]
        
        if ( Number(this.$route.query.step) === 3 ) {
          if ( this.applicationWasCreatedByCompany && this.selectedApplication?.state?.state === 'confirmedByCompany' ) {
            this.transferDialogIsVisible = true
          }
        }
      },

      immediate: true
    }
  },  
  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isApprentice', 'isCompanyUser']),
    ...mapGetters('application', ['currentStep', 'selectedApplication']),
    ...mapGetters('basic', ['basicProfessions', 'hasProfessionOrientations']),
    /**
     * @vuese
     * Used get all profession or search professions if search is required from user
     */
    searchedItems() {
      var result = []
      if (this.search === '') {
        result = this.basicProfessions
      } else {
        let normalizedSearch = this.search.toLowerCase()
        result = this.basicProfessions.filter(x => x.shortname.toLowerCase().includes(normalizedSearch))
      }
      return result
    },

    applicationWasCreatedByCompany() {
      return get(this, 'selectedApplication.isCompanyApplication', false)
    },

    transferOldProfession() {
      const apprenticeships = get(this, 'currentUser.apprenticeships', [])
      if ( !apprenticeships.length ) return false

      return apprenticeships.some(ap => {
        const foundSameProfession = ap?.professionId === this.profession?.id

        const foundActiveBook = get(this, 'currentUser.books', [])
          .some(book => book?.apprenticeshipId === ap?.id && !book?.isApprovedByInstructor)

        const foundActiveQualifyingTime = get(this, 'currentUser.educations', [])
          .some(ed => ed?.id === ap?.educationId && ed.qualificationTime?.isApprovedByInstructor === null)

        return (
          foundSameProfession &&
          (foundActiveBook || foundActiveQualifyingTime)
        )
      })
    }
  },
  methods: {

    get,

    ...mapActions('application', ['updateSelectedApplication']),

    /**
     * @vuese
     * Used to Initialize application with either selected professions or empty application profession
     */
    initApplication() {
      //- Initialize application with either selected or empty application
      if (this.selectedApplication && this.selectedApplication.id) {
        this.application = pick(this.selectedApplication, this.fields)
      } else {
        this.application = Object.fromEntries(
          this.fields.map(f => {
            return [f, null]
          })
        )
        //- And add defaults
        if (this.currentUser) {
          this.application.personalNumber = this.currentUser.personalNumber
        }
      }
      this.application.step = this.currentStep
      if (this.application && this.application.professionId && this.application.professionId > 0) {
        this.dissBtn = false
        this.activeColor = '#f8e805!important'
      }
      this.fetchProfessions()
    },

    /**
     * @vuese
     * Used to fetch professions and get the selected profession if there is any
     */
    fetchProfessions() {
      if (!get(this, 'selectedApplication.id', null)) return

      this.model = this.basicProfessions.findIndex(x => x.id === this.selectedApplication.professionId)
      
      if(this.selectedApplication.professionId && this.selectedApplication.professionId>0)
      {
        this.application.professionId = this.selectedApplication.professionId  
      } else {
        this.application.professionId = get(this, 'professions[0].id', 839)
      }
    },

    /**
     * @vuese
     * Used to got to a previous step
     */
    clickBack() {
      this.model = this.basicProfessions.findIndex(x => x.id === this.selectedApplication.professionId)
      this.$emit('goToStep', '-1')
    },

    /**
     * @vuese
     * Used to set profession id based on which profession user has selected
     */
    clickProfession(item) {
      this.dissBtn = false

      if (this.application && this.application.professionId != item.id) {
        //- Reset orientations on profession change
        this.application.saveProfessionOrientations = []
        this.application.professionOrientations = []
      }
      if (this.application) {
        this.application.professionId = item.id
      }
    },
    fetchCourses(gugs) {   
      let applicationCourses= [] 
      if (this.selectedApplication && this.selectedApplication.professionId > 0) {
        API.listProfessionCourses(this.selectedApplication.professionId)
          .then((response) => {      
            let listProfessionCourses = _.values(response.data)
            listProfessionCourses.forEach(pc => {
              pc.forEach(c => {
                let find = gugs.find(g => g.courseCode==c.courseCode)
                if(find)
                {
                  applicationCourses.push({
                    courseId: c.id,
                    applicationId: this.selectedApplication.id,
                    courseCode: find.courseCode,
                    approved: find.approved
                  })
                }
              })
            });
            
            API.updateApplication(this.selectedApplication.id, {
              data: {
                applicationCourses: applicationCourses    
              },
            })
            .then((res) => {                
                this.updateSelectedApplication(res.data);
                this.selectedApplication.applicationCourses=applicationCourses            
            })
            .catch((error) => {
              this.$events.fire("showError", this.$t("errors.save-failure"));
              console.log("There was an error:", error);
            });
          })
          .catch((error) => {
            console.log("get courses error", error);

          });        
      }
    },
    getPersonGugCourses() {       
      API.getPersonGugCourses()
        .then(res => { 
          this.gugCourses = res.data
          this.selectedApplication.gugCourses = res.data
          this.fetchCourses(res.data)                              
        })
        .catch(error => {
          this.$events.fire('showInfo', this.$t('application.documents.gugError'))
          console.log(error)
        })
    },

    readInformation() {
      if ( !this.applicationWasCreatedByCompany ) {
        this.haveReadInformation = true
        return this.nextStep()
      }

      return this.initializeProfessionTransfer()
    },

    /**
     * @vuese
     * Used to go to the next step if form is valid and update the application with new criterias
     * @arg The argument is an integer value application  id and params are the orientations selected
     */
    nextStep() {
      if (this.application && this.application.professionId && this.application.professionId > 0) {
        
        if(this.transferOldProfession) {
          this.transferDialogIsVisible = true

          if ( this.hasProfessionOrientations(this.application.professionId) ) {
            this.transferDialogIsVisible = false
            this.transferMachineProffesionDialog = true
          }

          if( !this.haveReadInformation && (this.transferDialogIsVisible || this.transferMachineProffesionDialog) ) 
            return

          this.initializeProfessionTransfer()
        }
          
        if(this.application.professionId!=this.selectedApplication.professionId)
        {
          this.getPersonGugCourses()
        }

        this.selectedApplication.professionId = this.application.professionId
        this.selectedApplication.professionOrientations = this.application.professionOrientations
        this.selectedApplication.step = this.currentStep
        API.updateApplication(this.application.id, {
          data: this.application
        })
          .then(() => {
            if (this.application.saveProfessionOrientations) {
              delete this.application.saveProfessionOrientations
            }
            /**
             * @vuese
             * Used to update application in vuex store with profession  selected
             */
            this.updateSelectedApplication(this.application)
            
            // Fire +1 if his company application or +2 if the selected profession has orientations
            // @arg The argument is a integer representing (in which step to go)

            if (
              this.selectedApplication.professionId &&
              this.hasProfessionOrientations(this.selectedApplication.professionId)
            ) {
              this.$emit('goToStep', '+1')
            } else {
              this.$emit('goToStep', '+2')
            }
          })
          .catch(error => {
            this.$events.fire('showError', this.$t('errors.form-validation'))
          })
          .finally(() => this.transferDialogIsVisible = false)
      } else {
        this.$events.fire('showError', this.$t('application.profession.non-selected'))
        return
      }
    },

    initializeProfessionTransfer() {
      this.unselectOrientations()
      this.application.transferOldProfession = true

      const educationOrientations = get(this, 'currentUser.educations', []).find(({ professionId }) => 
        get(this, 'profession.id', -1))?.educationProfessionOrientations

      if ( educationOrientations.length )
        this.application.professionOrientations = educationOrientations

      this.updateSelectedApplication(this.application)

      let step = 7
      if ( this.applicationWasCreatedByCompany )
        step = 9

      return this.$emit('goToStep', step)
    },

    closeApplicationTransferDialog() {
      this.transferDialogIsVisible = false
      this.transferMachineProffesionDialog = false

      if(this.applicationWasCreatedByCompany)
        return this.$router.replace({ name: 'ApplicationStart' })
    },

    unselectOrientations() {
      this.application.professionOrientations = []
      this.application.saveProfessionOrientations = []
    },

    createNewApplication() {
      this.unselectOrientations()
      if ( this.transferMachineProffesionDialog || this.transferDialogIsVisible ) {
        this.application.transferOldProfession = false
        this.updateSelectedApplication(this.application)
      }

      this.$emit('goToStep', 4)
    }
  }
}
</script>
